<template>
  <div>
    <!-- 搜索/新增 -->
    <div class="list-hd">
      <el-form :inline="true" v-model="searchValue" class="demo-form-inline">
        <el-form-item label="游戏:">
          <el-select
            v-model="searchValue.game_id"
            filterable
            clearable
            placeholder="请选择"
            @change="selectChannel"
            @clear="gameClear"
          >
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道:">
          <el-select
            v-model="searchValue.channel_id"
            filterable
            clearable
            multiple
            collapse-tags
            placeholder="请选择"
          >
            <el-option
              v-for="(item, i) in channelSelectList"
              :key="i"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区服:">
          <el-select
            v-model="searchValue.zone_id"
            filterable
            clearable
            multiple
            collapse-tags
            placeholder="请选择"
          >
            <el-option
              v-for="(item, i) in serverSelectList"
              :key="i"
              :label="item.name"
              :value="item.zone_id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="日期:">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="渠道包组:">
          <el-select
            v-model="searchValue.group_channel_ids"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelGroupSelectList"
              :key="item.id"
              :label="item.group_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账号:">
          <el-input v-model="searchValue.username" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="角色名:">
          <el-input v-model="searchValue.role_name" placeholder="请输入角色名"></el-input>
        </el-form-item>
        <el-form-item label="充值金额范围:">
          <div class="scope">
            <el-input v-model="payNum1" placeholder="填写数值"></el-input>
            <span>-</span>
            <el-input v-model="payNum2" placeholder="填写数值"></el-input>
          </div>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="searchRfmStatisticsList"
            >搜索</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="exportRfmStatisticsDay()"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :max-height="tableHeight"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="game.game_name"
        label="游戏"
      ></el-table-column>
      <el-table-column prop="channels.channel_name" label="渠道名">
      </el-table-column>

      <el-table-column
        v-if="searchValue.zone_id.length != 0"
        prop="zone_name"
        label="区服"
      ></el-table-column>
      <el-table-column prop="user.username" label="用户账号"> </el-table-column>
      <el-table-column prop="role_name" label="角色名"> </el-table-column>
      <el-table-column prop="money" label="充值金额"> </el-table-column>
      <el-table-column prop="order_num" label="充值总次数"> </el-table-column>
      <el-table-column prop="at_days" label="停充天数"> </el-table-column>
      <el-table-column prop="away_days" label="离线天数"> </el-table-column>
      <el-table-column prop="reg_time" label="角色创建时间"> </el-table-column>
      <el-table-column prop="repet_role" label="是否滚服角色">
      </el-table-column>
      <el-table-column prop="total_login" label="累计活跃天数">
      </el-table-column>
      <el-table-column prop="aways" label="是否流失用户"> </el-table-column>
      <el-table-column prop="level" label="角色等级"> </el-table-column>
      <el-table-column prop="first_time" label="首充时间"> </el-table-column>
      <el-table-column prop="last_time" label="最后充值时间"> </el-table-column>
      <el-table-column prop="login_role_count" label="最后登录日期">
      </el-table-column>
      <el-table-column prop="avg_days" label="平均充值间隔"> </el-table-column>
      <el-table-column prop="avg_num" label="平均充值次数"> </el-table-column>
      <el-table-column prop="avg_money" label="平均充值金额"> </el-table-column>
      <el-table-column prop="first_pay_gap" label="注册到首充间隔">
      </el-table-column>
      <el-table-column prop="last_login" label="最后登录日期" width="110">
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[15, 30, 45, 60]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import { urlSplicing } from "@/assets/js/public.js";
import moment from "moment";
export default {
  name: "rfmStatistics",
  components: {},
  data() {
    return {
      loadingData: false,
      searchValue: {
        game_id: "",
        channel_id: [],
        zone_id: [],
        created_from: "",
        created_to: "",
        group_channel_ids: "",
        money: "",
        username: "",
        role_name: "",
      },
      value1: [],
      tableHeight: 0,
      historyValue: {},
      tableData: [],
      gamesList: [],
      loginDetailData: [],
      channelSelectList: [],
      channelSelectAllList: [],
      serverSelectList: [],
      channelGroupSelectList: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 15,
      payNum1: "",
      payNum2: "",
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    this.value1[0] = moment().startOf("month").format("YYYY-MM-DD");
    this.value1[1] = moment().endOf("month").format("YYYY-MM-DD");

    this.searchValue.created_from = this.value1[0];
    this.searchValue.created_to = this.value1[1];
    this.getchannelSelectList();
    this.channelGroupSelect();
    this.getGameSelectList();
    this.getRfmStatisticsList(true);
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getRfmStatisticsList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getRfmStatisticsList(false);
    },

    //RFM模型管理数据列表 导出
    exportRfmStatisticsDay() {
      let params = {
        ...this.historyValue, // 传对应的搜索的值
        export: 1,
        token: sessionStorage.getItem("access_token"),
      };

      urlSplicing(this.host + "admin/cycle_statistics/rfm_role", params);
    },
    // 获取游戏选择列表数据
    getGameSelectList() {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        if (res.data.status) {
          this.gamesList = res.data.data;
        }
      });
    },

    // 获取渠道选择列表数据
    getchannelSelectList() {
      fetch({
        url: "/admin/channels/select",
        method: "GET",
      }).then((res) => {
        if (res.data.status) {
          this.channelSelectAllList = res.data.data;
          this.channelSelectList = res.data.data;
        }
      });
    },
    // 渠道包组 下拉选择列表
    channelGroupSelect() {
      fetch({
        url: "/admin/channel_package_group/select",
        method: "GET",
      }).then((res) => {
        this.channelGroupSelectList = res.data.data;
      });
    },

    // 获取区服选择列表数据
    getServerSelectList(vid) {
      fetch({
        url: "/admin/zones/select",
        method: "GET",
        params: {
          game_id: vid,
        },
      }).then((res) => {
        if (res.data.status) {
          this.serverSelectList = res.data.data;
        }
      });
    },

    // 根据所属游戏,显示对应的所属渠道/区服
    selectChannel(vid) {
      this.searchValue.zone_id = [];
      this.searchValue.channel_id = [];
      this.channelSelectList = [];
      this.channelSelectAllList.forEach((item, i) => {
        if (item.game_id == vid) {
          this.channelSelectList.push(item);
        }
      });
      if (vid) {
        this.getServerSelectList(vid);
      }
    },
    // 清空游戏选项
    gameClear() {
      this.searchValue.zone_id = [];
      this.searchValue.channel_id = [];
      this.serverSelectList = [];

      this.getchannelSelectList();
    },
    // 实现RFM模型管理数据列表的搜索
    searchRfmStatisticsList() {
      this.searchValue.created_from = this.value1 && this.value1.length === 2 ? this.value1[0] : '';
      this.searchValue.created_to = this.value1 && this.value1.length === 2 ? this.value1[1] : '';
      this.currentPage = 1;
      this.getRfmStatisticsList(true);
    },

    //获取 RFM模型管理 列表
    getRfmStatisticsList(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      let channel_id = this.searchValue.channel_id.toString();
      let zone_id = this.searchValue.zone_id.toString();
      if (this.payNum1 == "" && this.payNum2 == "") {
        this.searchValue.money = "";
      } else {
        this.searchValue.money = this.payNum1 + "-" + this.payNum2;
      }

      fetch({
        url: "admin/cycle_statistics/rfm_role",
        method: "GET",
        params: {
          ...searchValue,
          channel_id: channel_id,
          zone_id: zone_id,
          money: this.searchValue.money,
          page: this.currentPage,
          per_page: this.pageSize,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data.data;
            this.totalRecords = res.data.data.total;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
  },
};
</script>
<style lang="less">
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  .el-input-group {
    width: 370px;
  }
}
.scope {
  display: flex;
  span {
    display: inline-block;
    padding: 0 10px;
  }
  .el-input {
    width: 100px;
  }
}
</style>
